export default __webpack_public_path__ + "static/media/central_andes_1_16.5ed94a6a.JPG";